import { css, styled } from 'styled-components';
import { Size } from '../../types';

interface CardProps {
    $fillParent: boolean;
    $minHeight?: number;
    $background?: string;
    size?: Size;
}

const baseCard = css<CardProps>`
    display: flex;
    box-sizing: border-box;
    align-items: start;
    flex-direction: column;
    flex: ${({ $fillParent }) => ($fillParent ? 'initial' : 0)};
    background: ${({ theme, $background }) => $background || theme.cardBackground};
    border: ${({ theme }) => theme.cardBorder};
    border-radius: ${({ theme }) => theme.cardBorderRadius};
    ${({ $fillParent }) => $fillParent && 'width: 100%; height: 100%;'};
    padding: ${({ theme, size }) =>
        size === Size.LARGE ? theme.cardPaddingLarge : theme.cardPadding}px;
    ${({ $minHeight }) => $minHeight && `min-height: ${$minHeight}px;`}

    @media print {
        border: ${({ theme }) => theme.cardBorderPrint};
    }
`;

export const Card = styled.button<CardProps>`
    ${baseCard}
    text-align: left;
    cursor: pointer;
`;

export const CardStatic = styled.div<CardProps>`
    ${baseCard}
    cursor: auto;
`;

export const ThumbnailContainer = styled.div`
    justify-content: center;
    display: flex;
    margin-right: ${({ theme }) => theme.spacing(2)};
`;

export const PrimaryContainer = styled.div`
    display: flex;
    align-items: start;
    width: 100%;
    flex: 0;

    /* The Composite holding the thumbnail and title: see TitleContainer. */
    > * {
        min-width: 0;
    }
`;

export const TitleContainer = styled.div<{ size: Size }>`
    display: flex;
    flex-direction: column;
    flex: 1 100%;
    width: auto;
    /* A flex item won't shrink below its longest word by default, so a long title would run out
       of the card instead of wrapping. */
    min-width: 0;
    gap: ${({ size, theme }) => (size === Size.LARGE ? theme.spacing(2) : theme.spacing(1))};
`;

export const SecondaryContent = styled.div<{
    align?: string;
    justify?: string;
    direction?: string;
}>`
    display: flex;
    flex: 1 1;
    align-self: stretch;
    justify-self: stretch;
    justify-content: ${({ justify }) => justify || 'inherit'};
    align-items: ${({ align }) => align || 'end'};
    flex-direction: ${({ direction }) => direction || 'row'};
`;
